module.exports = __webpack_public_path__ + "assets/img/noInfo.0cfc0815.png";